import React, { useContext, useState, RefObject, MouseEvent } from "react";
import { theme, websiteColors } from "../../themes/Theme";
import Link from "next/link";
import { hostEventUrl } from "../../config/config";
import AuthContext from "../../contexts/AuthContext";
import { handleOnLogin } from "../../utils/utils";

interface DrawerMenuProps {
	onClose: () => void;
	isHomePage?: boolean;
	handleLogout: (e?: MouseEvent<HTMLElement>) => void;
}

interface AuthContextType {
	signedIn: boolean | null;
	user: {
		attributes: {
			[key: string]: any;
		};
	};
	setAuth: (user: { attributes: any }, authenticated: boolean) => void;
}

const DrawerMenu: React.FC<DrawerMenuProps> = ({ onClose, isHomePage = false, handleLogout }) => {
	const [isResourcesOpen, setIsResourcesOpen] = useState<boolean>(false);
	const authContext = useContext(AuthContext) as AuthContextType;

	const toggleResources = (): void => {
		setIsResourcesOpen(!isResourcesOpen);
	};

	const style: React.CSSProperties = {
		textDecoration: "none"
	};

	return (
		<div className="overlay font-figtree">
			<div
				className={`offcanvas offcanvas-end show`}
				style={{
					visibility: "visible",
					backgroundColor: "#fff",
					transition: "0.5s"
				}}
			>
				<div className="offcanvas-header">
					<button type="button" className="btn-close" onClick={onClose}></button>
				</div>
				<div className="offcanvas-body">
					<div className="d-flex flex-column gap-3 mb-4">
						{authContext.signedIn === true && (
							<div className="d-flex px-1 py-2 text-left switchEvent-pad pt-3">
								<div className="pr-0">
									<img
										className="profile-dropDown-img profile-container"
										src={authContext.user.attributes["custom:profilePicture"]}
										alt="Profile"
									/>
								</div>
								<div className="details-container ms-2 pl-0 pr-0 mt-auto mb-auto">
									<p className="h5 profile-email mb-0 drawer-link-color">
										{authContext.user.attributes.name}
									</p>
									<p
										className="profile-sub-text mb-0"
										style={{ color: "#808080" }}
									>
										{authContext.user.attributes.email}
									</p>
								</div>
							</div>
						)}
						<a
							href={`${hostEventUrl}/create/event`}
							className="text-decoration-none host-btn-wt host-btn fw-bold font-sm"
						>
							Host a Marathon
						</a>
						{authContext.signedIn === false && (
							<a
								onClick={(e: MouseEvent<HTMLElement>) =>
									handleOnLogin(e, authContext)
								}
								className="login-btn text-decoration-none text-pricing demo-btn fw-bold font-sm"
							>
								Log in
							</a>
						)}
					</div>

					<ul className="list-group list-unstyled">
						<li className="list-group-item">
							<Link
								href="https://dev.konfhub.com/events"
								className="text-pricing"
								style={{ textDecoration: "none" }}
							>
								Marathon
							</Link>
						</li>
						<li className="list-group-item">
							<Link
								href="https://dev.konfhub.com/pricing"
								className="text-pricing"
								style={{ textDecoration: "none" }}
							>
								Pricing
							</Link>
						</li>
						{authContext.signedIn === true && (
							<div style={{ fontWeight: "600" }}>
								<hr className="mt-2 nav-mob" />
								<a
									href={`${hostEventUrl}`}
									target="_blank"
									rel="noopener noreferrer"
									className="text-decoration-none drawer-link-color d-block pb-2"
								>
									<span className="text-pricing">Dashboard</span>
								</a>
								<Link
									href="/profile"
									style={style}
									className="d-block text-pricing py-2 drawer-link-color"
								>
									Manage Profile
								</Link>
								<Link
									href="/bookings"
									style={style}
									className="d-block text-pricing py-2 drawer-link-color"
								>
									My Bookings
								</Link>
								<hr className="mt-2 nav-mob" />
								<span
									className="me-2 py-2"
									style={{
										color: "#525252",
										cursor: "pointer",
										letterSpacing: "0px"
									}}
									onClick={(e: MouseEvent<HTMLElement>) => handleLogout(e)}
								>
									Logout{" "}
									<img
										src="https://d2nnrpx7gk2my2.cloudfront.net/files/672c650d97b04e000924da19/Logout.svg"
										alt="logout icon"
									/>
								</span>
							</div>
						)}
					</ul>
				</div>
			</div>

			<div className="offcanvas-backdrop fade show" onClick={onClose}></div>

			<style jsx>{`
				.offcanvas {
					width: 300px;
					background: white;
					position: fixed;
					top: 0;
					right: 0;
					bottom: 0;
					z-index: 1045;
					transition: transform 0.5s ease;
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
				}
				.show {
					transform: translateX(0);
				}
				.offcanvas-header {
					display: flex;
					justify-content: space-between;
					padding: 15px;
				}
				.offcanvas-body {
					padding: 20px;
				}
				.drawer-link-color {
					color: #525252 !important;
				}
				.btn-close {
					background-color: transparent;
					border: none;
					cursor: pointer;
					font-size: 20px;
				}
				.btn-outline-primary {
					border: 1px solid #0d6efd;
					color: #0d6efd;
					background-color: transparent;
					padding: 10px 15px;
					border-radius: 5px;
				}
				.btn-primary {
					background-color: #0d6efd;
					color: white;
					padding: 10px 15px;
					border-radius: 5px;
				}
				.list-group-item {
					border: none;
					padding: 10px 0;
					font-size: 16px;
					font-weight: 600;
					line-height: 26.4px;
				}
				.dropdown-items {
					background-color: #fafbfd !important;
				}
				.list-group-item a {
					text-decoration: none;
					color: ${websiteColors[theme].textSecondary};
				}
				.list-group-item:hover a {
					color: #0d6efd;
				}
				.list-group-item a:hover {
					text-decoration: underline;
				}
				.btn-close {
					background-color: transparent;
					border: none;
					cursor: pointer;
					font-size: 15px;
				}
				.overlay {
					position: fixed;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: rgba(0, 0, 0, 0.5);
					z-index: 999;
				}
				.host-btn {
					box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
					font-weight: 600;
					background-color: ${websiteColors[theme].primaryWebsiteTheme};
					color: #fff;
					padding: 10px 40px;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.demo-btn {
					box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
					font-weight: 600;
					display: flex;
					align-items: center;
					justify-content: center;
					color: ${websiteColors[theme].primaryWebsiteTheme};
					padding: 10px 40px;
					border-radius: 4px;
					border: 1px solid ${websiteColors[theme].primaryWebsiteTheme};
					background-color: #fff;
				}
				.login-btn {
					cursor: pointer;
				}
			`}</style>
		</div>
	);
};

export default DrawerMenu;
